import { GRAPHQL_ENDPOINT } from '@/constants/global'
import { ApolloClient, InMemoryCache } from '@apollo/client'
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs'

const client = new ApolloClient({
  link: createUploadLink({ uri: GRAPHQL_ENDPOINT }),
  cache: new InMemoryCache()
})

export default client
